<template>
  <!-- 表格 -->
  <div>
    <div class="report_title">
      <label class="report-line" />
      <span class="report-title">月成交汇总</span>
      <exportConfig
        :all-head="allHead"
        :header-name="headerName"
      />
    </div>
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <af-table-column
        fixed
        prop="tradingDateStr"
        label="成交日期"
      />
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        fixed
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="entrustBsName"
        label="购/销"
      />
      <af-table-column
        prop="totalAmount"
        label="总成交量"
      />
      <af-table-column
        prop="signBuySumAmount"
        label="订立量"
      />
      <af-table-column
        prop="signBuyAvgPrice"
        label="订立均价"
      />
      <af-table-column
        prop="transferBuySumAmount"
        label="变更量"
      />
      <af-table-column
        prop="transferBuyAvgPrice"
        label="变更均价"
      />
      <af-table-column
        prop="presentChangeWarehouse"
        label="变今仓量"
      />
      <af-table-column
        prop="unPresentChangeWarehouse"
        label="非变今仓量"
      />
      <af-table-column
        prop="tradeCompanyCode"
        label="贸易公司"
        width="250"
      />
    </el-table>
    <MoreData
      :all-data="allData"
      :table-data.sync="tableData"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'
import MoreData from '@/components/more-data'
import exportConfig from '@/components/exportConfig'

export default {
  name: 'MonthlyClosingSummary',
  components: {
    MoreData,
    exportConfig,
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allHead: [{
        fieldLabel: '成交日期',
        excelColumn: 'tradingDateStr'
      },
      {
        fieldLabel: '客户号',
        excelColumn: 'tradeUserAccount'
      },
      {
        fieldLabel: '购销计划',
        excelColumn: 'goodsCode'
      },
      {
        fieldLabel: '购/销',
        excelColumn: 'entrustBsName'
      },
      {
        fieldLabel: '总成交量',
        excelColumn: 'totalAmount'
      },
      {
        fieldLabel: '订立量',
        excelColumn: 'signBuySumAmount'
      },
      {
        fieldLabel: '订立均价',
        excelColumn: 'signBuyAvgPrice'
      },
      {
        fieldLabel: '变更量',
        excelColumn: 'transferBuySumAmount'
      },
      {
        fieldLabel: '变更均价',
        excelColumn: 'transferBuyAvgPrice'
      },
      {
        fieldLabel: '变今仓量',
        excelColumn: 'presentChangeWarehouse'
      },
      {
        fieldLabel: '非变今仓量',
        excelColumn: 'unPresentChangeWarehouse'
      },
      {
        fieldLabel: '贸易公司',
        excelColumn: 'tradeCompanyCode'
      },
      ],
      headerName: '月报表_月成交汇总',
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      allData: [],
    }
  },
  methods: {
    // 分页查询
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.monthDate = dayJs(this.query.date).format('YYYYMM')
      let res = await api.spotPurchaseSaleInquiry.MonthlyClosingSummary(param)
      this.allData = res.data || []
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
    changeSort (prop) {},
  }
}

</script>

<style lang="scss" scoped>
  ::v-deep .el-table .el-table__body-wrapper tbody>tr:last-child td:nth-child(8) div {
    display: none;
  }

</style>
